import type { ImageGridModule } from 'types/capi/article';

import ExternalIcon from '~/assets/icons/ExternalIcon';
import AffiliatePageLink from '~/components/AffiliatePageLink';
import Image from '~/components/Image';

type Props = {
  items: ImageGridModule['items'];
};

export default function ImageGrid({ items }: Props) {
  const imageCount = Math.min(items.length, 2);

  return (
    <div className="flex w-full items-center justify-center px-4 md:px-10">
      <div
        className={`grid ${imageCount === 1 ? 'grid-cols-1 md:max-w-xl' : 'max-w-6xl grid-cols-1 md:grid-cols-2'} gap-4 md:gap-6 `}
      >
        {items.map((image, index) => (
          <div key={image.url} className="relative flex flex-col">
            <div className="relative">
              <Image
                alt={image.alt || `image-${index}`}
                src={image.url}
                progressiveLoadSettings={{
                  highResQuality: 100,
                  lowResQuality: 50
                }}
                className="w-full md:w-[456px] lg:w-[552px]"
                loading="eager"
              />

              {image.cta && (
                <div className="absolute bottom-3 right-3">
                  <div className="w-auto max-w-40 flex-row truncate rounded-full bg-gray-800/70 px-3 py-1.5 text-sm text-grey-tile md:max-w-56">
                    {image.cta.url ? (
                      <AffiliatePageLink
                        urlTemplates={image.cta}
                        buttonName={`FEATURES_${image.cta.text}`}
                        pagePosition="Image Grid"
                        variant="none"
                        className="hover:underline"
                        affiliate={image.cta.affiliate}
                      >
                        <div className="flex items-center gap-2">
                          <div>
                            <ExternalIcon color="#FAFAFA" size={20} />
                          </div>
                          <span className="truncate">{image.cta.text}</span>
                        </div>
                      </AffiliatePageLink>
                    ) : (
                      image.cta.text
                    )}
                  </div>
                </div>
              )}
            </div>
            {image.caption && (
              <p className="mt-2 text-sm text-grey-hide">{image.caption}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
